import { useSearchTerritoryPageSelectorModel } from './search-territory-page-selector.model'
import { SearchTerritoryPageSelectorView } from './search-territory-page-selector.view'

export const SearchTerritoryPageSelector = () => {
  const searchTerritoryPageSelectorModel = useSearchTerritoryPageSelectorModel()
  return <SearchTerritoryPageSelectorView {...searchTerritoryPageSelectorModel} />
}
